import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { v } from '../../styles/variables'
export const SNavbar = styled.nav`
	width: 100%;
    position: fixed;
    bottom: 92%
	height: ${(props) => (props.extendNavbar ? '100vh' : '80px')};
	background-color: ${({ theme }) => theme.bgf};
	display: flex;
	flex-direction: column;
    border-bottom: 1px solid ${({ theme }) => theme.bg3};
    z-index: 10;
	@media (min-width: ${v.mobileMaxWidth}) {
		height: 80px;
	}
`

export const SLeftContainer = styled.div`
	flex: 70%;
	display: flex;
	align-items: center;
	padding-left: 1%;
`

export const SRightContainer = styled.div`
	flex: 30%;
	display: flex;
	justify-content: flex-end;
	padding-right: 50px;
`
export const SThemeModeIconContainer = styled.div`
	padding: ${v.smSpacing} ${v.mdSpacing};
	display: flex;
	align-items: center;
	svg {
		font-size: 40px;
	}
	@media (max-width: ${v.mobileMaxWidth}) {
		margin-right: 30px;
	}
`
export const SNavbarInnerContainer = styled.div`
	width: 100%;
	height: 80px;
	display: flex;
`

export const SNavbarLinkContainer = styled.div`
	display: flex;
	padding-left: 2%;
`

export const SNavbarLink = styled(Link)`
	color: inherit;
	font-size: x-large;
	text-decoration: none;
	margin: 10px;
	padding: 10px;
	border: 2px solid ${({ theme }) => theme.text};
	border-radius: 10px;
	@media (max-width: ${v.mobileMaxWidth}) {
		display: none;
	}
	&:hover {
		color: ${({ theme }) => theme.highlight};
	}
`

export const STCREFFERALNavbarLink = styled(Link)`
	color: white;
	font-size: large;
	text-decoration: none;
	margin: 10px;
	padding: 10px;
	max-width: 200px;
	background-color: #11c70e;
	text-align: center;
	display: flex; /* Use flexbox to align icon and text */
	align-items: center; /* Vertically center the icon and text */
	justify-content: center; /* Horizontally center the content */
	border-radius: ${v.borderRadius};
	@media (max-width: ${v.mobileMaxWidth}) {
		display: none;
	}
	&:hover {
		background-color: green;
		color: white;
	}
`

export const NavbarInfo = styled.div`
	color: white;
	font-size: medium;
	text-decoration: none;
	margin: 15px;
	max-width: 400px;
	background-color: #4476f2;
	text-align: center;

	border-radius: ${v.borderRadius};
	@media (max-width: ${v.mobileMaxWidth}) {
		display: none;
	}
`

export const NavbarDonatePopup = styled(Link)`
	color: ${({ theme }) => theme.text};
	font-size: large;
	text-decoration: none;
	margin: 10px;
	padding: 10px;
	max-width: 200px;
	text-align: center;
	border: 2px solid ${({ theme }) => theme.text};
	border-radius: 10px;
	display: flex; /* Use flexbox to align icon and text */
	align-items: center; /* Vertically center the icon and text */
	justify-content: center; /* Horizontally center the content */
	@media (max-width: ${v.mobileMaxWidth}) {
		display: none;
	}
	& svg {
		margin-right: 8px; /* Space between icon and text */
		font-size: 1.2em; /* Adjust icon size */
	}
	&:hover {
		color: ${({ theme }) => theme.highlight};
		& svg {
			color: ${({ theme }) => theme.highlight}; /* Match icon color on hover */
		}
	}
`
export const SNavbarLinkExtended = styled(Link)`
	color: inherit;
	font-size: x-large;
	text-decoration: none;
	margin: 10px;
	&:hover {
		color: ${({ theme }) => theme.highlight};
	}
`

export const SLogo = styled.img`
	margin: 10px;
	max-width: 200px;
	height: auto;
`
export const SOpenLinksButton = styled.button`
	width: 70px;
	height: 50px;
	background: none;
	border: none;
	padding: ${v.smSpacing} ${v.mdSpacing};
	display: flex;
	align-items: center;

	color: inherit;
	font-size: 45px;
	cursor: pointer;
	position: fixed;
	right: 2%;
	top: 2%;
	@media (min-width: ${v.mobileMaxWidth}) {
		display: none;
	}
`

export const SNavbarExtendedContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: 100;
	@media (min-width: ${v.mobileMaxWidth}) {
		display: none;
	}
`
